import Vue from 'vue'
import ElementUI from 'element-ui'
import App from './App'
import router from './router'
import store from './store'
import locale from 'element-ui/lib/locale/lang/en'
import moment from 'moment'
import VueHotkey from 'v-hotkey'
import DlgDraggable from 'vue-element-dialog-draggable'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faKey, faUser, faCog, faServer, faSearch, faTimes, faPlus, faStar as fasStar, faCalendarAlt, faList, faClipboard, faPlane,
  faChartPie, faBars, faLock, faDollarSign, faSort, faSortUp, faSortDown, faClock, faRandom, faCheck, faStopwatch, faUserAstronaut, faGift, faStop,
  faPlay, faPause, faDownload, faInfo, faChevronRight, faChevronLeft, faLink, faChartBar, faExclamationCircle, faCaretDown, faCaretUp, faHeart, faTimesCircle,
  faSearchPlus, faSearchMinus, faCalendarDay, faExpand
} from '@fortawesome/free-solid-svg-icons'
import { faStar as farStar } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import * as Sentry from '@sentry/browser'
import 'moment-timezone'
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

library.add(faKey, faUser, faCog, faServer, faSearch, faTimes, faPlus, fasStar, farStar, faCalendarAlt, faList, faClipboard, faPlane,
  faChartPie, faBars, faLock, faDollarSign, faSort, faSortUp, faSortDown, faClock, faRandom, faCheck, faStopwatch, faUserAstronaut, faGift, faStop,
  faPlay, faPause, faDownload, faInfo, faChevronRight, faChevronLeft, faLink, faChartBar, faExclamationCircle, faCaretDown, faCaretUp, faHeart, faTimesCircle, faSearchPlus, faSearchMinus, faCalendarDay, faExpand)

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://afa74a9c15374f6c8f6dd87f0c534c68@sentry.io/1290727',
    integrations: [new Sentry.Integrations.Vue({ Vue })]
  })
}

let firstDayOfWeek = store.getters.firstDayOfWeek
moment.locale('en')
moment.updateLocale('en', {
  week: {
    dow: firstDayOfWeek,
    doy: 7 + firstDayOfWeek - 1
  }
})

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('RecycleScroller', RecycleScroller)

Vue.use(ElementUI, { locale })
Vue.use(VueHotkey)

Vue.config.productionTip = false
Vue.use(DlgDraggable)
Vue.config.performance = true

/* eslint-disable no-new */
window.app = new Vue({
  components: { App },
  router,
  store,
  template: '<App/>',
  render: h => h(App)
}).$mount('#app')
